import Tooltip from "@mui/material/Tooltip"

interface TimeDetailIconProps {
  folder: string
  name: string
  icon: string
  height: string
}

export default function TimeDetailIcon(props: TimeDetailIconProps) {
  const { folder, name, icon, height } = props

  return (
    <Tooltip title={name} placement="right">
      <span>
        <img
          src={require("../assets/" + folder + "/" + icon.toLowerCase() + (folder === 'laps' ? '.svg' : ".png"))}
          alt={icon}
          height={height}
          style={{
            filter: "drop-shadow(0px 0px 3px rgba(127, 127, 127, 0.5))",
          }}
        />
      </span>
    </Tooltip>
  )
}